import PageMain from '../../components/Navigation/PageMain/PageMain';
import UsersList from '../../components/Settings/Users/UserList';
import { RequestStatus } from '../../sic-lib/enums/RequestStatus';
import { useAppSelector } from '../../store/hooks';

export default function ViewUsersPage() {
    /*
        TIP: request for page dependancies which should be resolved before 
        displaying page children
     */

    const statusRequest = useAppSelector(state => {
        return state.user?.requestStatus || RequestStatus.none;
    });

    return (
        <PageMain
            pageTitle="Users"
            showError={statusRequest === RequestStatus.error}
            showLoading={false}
            // showLoading={statusRequest !== RequestStatus.success}
        >
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <UsersList />
                </div>
            </div>
        </PageMain>
    );
}
